import { HistoryDotIcon, RightCaretArrow } from 'app/assets/icons';
import React from 'react';
import styled from 'styled-components';
import {
  formatDateDDM,
  formatTimeTo12Hour,
  useNavigateToRoute,
} from 'utils/common';
import { RectangleSkeletonLoader } from '../SkeletonLoader/RectangleSkeletonLoader';
import Cookies from 'js-cookie';

type Props = {
  data: any;
  title?: string;
  dataTestId?: string;
  onClick?: (e: any) => void;
  isLoading?: boolean;
  facilityId?: string | undefined;
  isLoanHistory?: boolean;
};
const HistoryList = ({
  data,
  title,
  dataTestId,
  onClick,
  isLoading,
  facilityId,
  isLoanHistory,
}: Props) => {
  const redirect = useNavigateToRoute();
  return (
    <StyledWrapper className="history-list-comp" data-id={dataTestId ?? ''}>
      <div className="list-header-block">{title}</div>
      <div className="content-list">
        <ul className="custom-history-list">
          {isLoading ? (
            <>
              <li className="history-items-list">
                <div className="indicator-block">
                  <div className="dot">
                    <HistoryDotIcon />
                  </div>
                  <div className="line-tracker"></div>
                </div>
                <div className="details">
                  <span className="action">
                    <RectangleSkeletonLoader
                      className="field-skeleton"
                      count={1}
                      height={20}
                      width={150}
                    />
                  </span>
                  <div className="timestamp">
                    <RectangleSkeletonLoader
                      className="field-skeleton"
                      count={1}
                      height={20}
                      width={50}
                    />
                  </div>
                </div>
              </li>
              <li className="history-items-list">
                <div className="indicator-block">
                  <div className="dot">
                    <HistoryDotIcon />
                  </div>
                  <div className="line-tracker"></div>
                </div>
                <div className="details">
                  <span className="action">
                    <RectangleSkeletonLoader
                      className="field-skeleton"
                      count={1}
                      height={20}
                      width={150}
                    />
                  </span>
                  <div className="timestamp">
                    <RectangleSkeletonLoader
                      className="field-skeleton"
                      count={1}
                      height={20}
                      width={50}
                    />
                  </div>
                </div>
              </li>
              <li className="history-items-list">
                <div className="indicator-block">
                  <div className="dot">
                    <HistoryDotIcon />
                  </div>
                  <div className="line-tracker"></div>
                </div>
                <div className="details">
                  <span className="action">
                    <RectangleSkeletonLoader
                      className="field-skeleton"
                      count={1}
                      height={20}
                      width={150}
                    />
                  </span>
                  <div className="timestamp">
                    <RectangleSkeletonLoader
                      className="field-skeleton"
                      count={1}
                      height={20}
                      width={50}
                    />
                  </div>
                </div>
              </li>
              <li className="history-items-list">
                <div className="indicator-block">
                  <div className="dot">
                    <HistoryDotIcon />
                  </div>
                  <div className="line-tracker"></div>
                </div>
                <div className="details">
                  <span className="action">
                    <RectangleSkeletonLoader
                      className="field-skeleton"
                      count={1}
                      height={20}
                      width={150}
                    />
                  </span>
                  <div className="timestamp">
                    <RectangleSkeletonLoader
                      className="field-skeleton"
                      count={1}
                      height={20}
                      width={50}
                    />
                  </div>
                </div>
              </li>
            </>
          ) : (
            data?.map((item, index) => (
              <li
                key={`${item.timestamp}-${index}`}
                className="history-items-list"
                onClick={() => onClick?.(item)}
              >
                <div className="indicator-block">
                  <div className="dot">
                    <HistoryDotIcon />
                  </div>
                  <div className="line-tracker"></div>
                </div>
                <div className="details">
                  <span className="name">{item.user}</span>{' '}
                  <span
                    className="action"
                    onClick={() => {
                      const cookiesPayload = {
                        action: item.action,
                        subEntityId: item.subEntityId,
                        timestamp: item.timestamp,
                        type: item.type,
                        user: item.user,
                        validFrom: item.validFrom,
                        validTo: item.validTo,
                        facilityId: facilityId,
                      };
                      Cookies.set(
                        'historyDetails',
                        JSON.stringify(cookiesPayload),
                      );
                      if (isLoanHistory) {
                        redirect(`/loan/loan-details/history-details`);
                      } else {
                        redirect(`/facility/facility-details/history-details`);
                      }
                    }}
                  >
                    {item.action}
                  </span>
                  <div className="timestamp">
                    {formatDateDDM(item?.timestamp)}
                    {'  '}
                    <span className="seperator">|</span>
                    {'  '}
                    {formatTimeTo12Hour(item?.timestamp)}
                  </div>
                </div>
                <div className="icon-block">
                  <RightCaretArrow />
                </div>
              </li>
            ))
          )}
        </ul>
      </div>
    </StyledWrapper>
  );
};

export default HistoryList;

const StyledWrapper = styled.div`
  width: 255px;
  border-radius: 15px;
  border: 1px solid ${p => p.theme.historyBorderClr};
  background: ${p => p.theme.white};
  box-shadow: 0px 3.5px 5.5px ${p => p.theme.historyBoxShadow};

  @media (max-width: 767.98px) {
    border: none;
    width: 100% !important;
    .content-list {
      padding: 31px 22px 55px 33px !important;
    }
    .list-header-block {
      display: none !important;
      &::after {
        height: 0px !important;
      }
    }
    .history-items-list {
      .indicator-block {
        .dot {
          svg {
            width: 24px !important;
            height: 24px !important;
          }
        }
        .line-tracker {
          top: 24px !important;
        }
      }
      .details {
        border: 1px solid ${p => p.theme.detailsBorderClr} !important;
        border-style: dashed !important;
        border-width: 0 0 1px 0 !important;
        width: 100% !important;
        padding: 0 0 6px 0 !important;
        margin: 0 0 0 10px !important;
        .name {
          font-size: 14px !important;
          line-height: 16.68px !important;
          margin: 0 0 14px 0;
          display: inline-block;
        }
        .action {
          font-size: 12px !important;
          font-weight: 600 !important;
          line-height: 18px !important;
          letter-spacing: -0.01em !important;
          width: 100%;
          display: block;
          text-transform: capitalize;
        }
        .timestamp {
          color: ${p => p.theme.mobileTimeLableClr} !important;
          font-size: 10px !important;
          font-weight: 600 !important;
          line-height: 13.62px !important;
          letter-spacing: -0.01em !important;
          margin-top: 7px !important;
          .seperator {
            display: inline-block !important;
          }
        }
      }
      .icon-block {
        display: unset !important;
        vertical-align: middle;
        align-content: center;
      }
    }
  }
  @media (min-width: 1441px) {
    width: 285px;
  }

  .list-header-block {
    padding: 15px 17px;
    font-family: 'Open Sans';
    font-size: 14px;
    font-weight: 600;
    line-height: 24px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: ${p => p.theme.black};
    position: relative;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      background: linear-gradient(${p => p.theme.linearGradientClr});
      width: 100%;
      height: 1px;
    }
  }

  .content-list {
    padding: 15px;

    .custom-history-list {
      list-style: none;
      padding: 0;
      margin: 0;

      .history-items-list {
        display: flex;
        margin-bottom: 15px;
        position: relative;
        .indicator-block {
          position: relative;
          .dot {
            position: relative;
            margin: 0 auto;
          }
          .line-tracker {
            position: absolute;
            top: 22px;
            left: 50%;
            border-radius: 20px;
            transform: translate(-50%, 0%);
            background: ${p => p.theme.lineBackgroundClr};
            width: 2px;
            height: calc(100% - 20px);
          }
        }

        .details {
          padding: 0 0 0 10px;
          .name {
            font-family: 'Open Sans';
            font-size: 12px;
            font-weight: 700;
            line-height: 16.8px;
            text-align: left;
            text-underline-position: from-font;
            text-decoration-skip-ink: none;
            color: ${p => p.theme.historyNameClr};
          }

          .action {
            font-family: 'Open Sans';
            font-size: 12px;
            font-weight: 400;
            line-height: 16.8px;
            text-align: left;
            text-decoration-line: underline;
            text-decoration-style: solid;
            text-underline-position: from-font;
            text-decoration-skip-ink: none;
            color: ${p => p.theme.actionLableClr};
            cursor: pointer;
            text-transform: capitalize;
            margin: 0 0 3px 0;
          }

          .timestamp {
            font-family: 'Open Sans';
            font-size: 11px;
            font-weight: 600;
            line-height: 16.5px;
            text-align: left;
            text-underline-position: from-font;
            text-decoration-skip-ink: none;
            color: ${p => p.theme.timeLableClr};
            margin-top: 4px;
            .seperator {
              display: none;
              margin: 0 1px;
            }
          }
        }
        .icon-block {
          display: none;
        }
      }
    }
  }
`;
